import { createContext, useContext } from "react";

// Storage key constants
export const KEY_ACTIVE_STORE = "storemandu:activeStoreId";
export const currencyKey = (id: string) => `storemandu:currency:${id}`;
export const languageKey = (id: string) => `storemandu:language:${id}`;

export interface CurrencyContextType {
  storeId: string | null;
  currency: string;
  language: string;
  isHydrated: boolean;
  isSyncing: boolean;
  setCurrency: (next: string) => void;
  setLanguage: (next: string) => void;
}

export const CurrencyContext = createContext<CurrencyContextType | undefined>(
  undefined,
);

export function useCurrency(): CurrencyContextType {
  const context = useContext(CurrencyContext);
  if (context === undefined) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return context;
}
